import { getUserState, getUserCustomer, postSubscriptionSubmitted, getUserQrcode, submitPromoCode, checkPromoCode } from '../../../helpers/api'

export default {
	getUserState: ({ commit }, token) => {
		commit('SET_LOADING', true)
		return getUserState(token).then((data) => {
			commit('SET_LOADING', false)
			commit('SET_USER_STATE', data.state)
			return Promise.resolve(data)
		}).catch((err) => {
			commit('SET_LOADING', false)
			throw err
		})
	},
	getUserCustomer: ({ commit }, token) => {
		commit('SET_LOADING', true)
		return getUserCustomer(token).then((data) => {
			commit('SET_LOADING', false)
			commit('SET_USER_CUSTOMER_ID', data.customer)
			commit('SET_USER_SUBSCRIPTION_ID', data.subscription)
			commit('SET_USER_SUBSCRIPTION_SECRET', data.clientSecret)
			commit('SET_SUBSCRIPTION_PAYMENT', {
				'amount'       : data.amount,
				'discount'     : data.discount,
				'has_trial'    : data.has_trial,
				'trial'        : data.trial,
				'sub_end'      : data.sub_end,
				'special_trial': Boolean(data.trial_special),
				'setup'        : data.setupIntent
			})
			return Promise.resolve(data)
		}).catch((err) => {
			commit('SET_LOADING', false)
			throw err
		})
	},
	subscriptionSubmitted: ({ commit }, { token, stripe, intent, invoice }) => {
		commit('SET_LOADING', true)
		return postSubscriptionSubmitted(token, stripe, intent, invoice).then((data) => {
			commit('SET_LOADING', false)
			commit('SET_USER_CUSTOMER_ID', null)
			commit('SET_USER_SUBSCRIPTION_ID', null)
			commit('SET_USER_SUBSCRIPTION_SECRET', null)
			commit('SET_SUBSCRIPTION_PAYMENT', null)
			return Promise.resolve(data)
		}).catch((err) => {
			commit('SET_LOADING', false)
			throw err
		})
	},
	getUserQrcode: ({ commit }, token) => {
		commit('SET_LOADING', true)
		return getUserQrcode(token).then((data) => {
			commit('SET_LOADING', false)
			commit('SET_USER_QRCODE', data.qrcode)
			return Promise.resolve(data)
		}).catch((err) => {
			commit('SET_LOADING', false)
			throw err
		})
	},
	submitPromoCode: ({ commit }, token, code) => {
		commit('SET_LOADING', true)
		return submitPromoCode(token, code).then((data) => {
			commit('SET_LOADING', false)
			commit('SET_USER_PROMO_CODE', null)
			if (data.state) commit('SET_USER_STATE', data.state)
			return Promise.resolve(data)
		}).catch((err) => {
			commit('SET_LOADING', false)
			throw err
		})
	},
	checkPromoCode: ({ commit }, code) => {
		commit('SET_LOADING', true)
		return checkPromoCode(code).then((data) => {
			commit('SET_LOADING', false)
			return Promise.resolve(data)
		}).catch((err) => {
			commit('SET_LOADING', false)
			throw err
		})
	}
}
